import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class ProductService extends Service {
    constructor() {
        super();
        this.baseURL = 'product/product';
    }

    async findAllMenu() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL+"/menu", {
            headers: { 'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'},
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async findProductByBarcode(barcode) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/barcode/" + barcode, {
            headers: { 'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async findProductByBarcodeWithDepos(barcode) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/barcodeWithDepos/" + barcode, {
            headers: { 'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async searchProductsByName(name) {
        const body = JSON.stringify({ name: name });
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/search", {
            method: "PUT",
            headers: {
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
                'Content-Type': 'application/json',
            },
            body: body
        })
            .then(response => response.json())
            .catch(error => {
                GeneralUtils.notification(error);
            });
    }

    async searchCodedProductsByName(name) {
        const body = JSON.stringify({ name: name });
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/search/coded", {
            method: "PUT",
            headers: {
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
                'Content-Type': 'application/json',
            },
            body: body
        })
            .then(response => response.json())
            .catch(error => {
                GeneralUtils.notification(error);
            });
    }


    async getNextBarcode() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/barcode/generate", {
            headers: { 'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async calculateWebPrice(data) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL+"/calculate/webprice", {
            crossDomain: true,
            method: 'post',
            headers: { 'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response,true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async updateStock(data) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL+"/stock", {
            crossDomain: true,
            method: 'put',
            headers: { 'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response,true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }




}